import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MainService } from 'src/app/services/main-service.service';
import { environment } from 'src/environments/environment';
declare var Stripe: any;

@Component({
  selector: 'app-g-pay',
  templateUrl: './g-pay.component.html',
  styleUrls: ['./g-pay.component.scss']
})
export class GPayComponent implements OnInit {
  current_env: any = environment.production != true ? 'TEST' : 'PRODUCTION';
  buttonColor: any = 'black';
  buttonType: any = 'pay';
  isCustomSize = false;
  buttonWidth = 240;
  buttonHeight = 40;
  isTop = window === window.top;
  paymentDataRequest: any;
  paymentsClient: any;
  stripe: any;

  // tslint:disable-next-line:no-input-rename
  @Input('final_amount') final_amount: any;
  @Output() confirmPayment = new EventEmitter<{ token: string, payment_source_type: number, wallet: number }>();
  paymentRequest: any = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: 'CARD',
        parameters: {
          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
          allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA']
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'stripe',
            'stripe:version': '2019-12-03',
            'stripe:publishableKey': this.mainservice.stripe_pk
          }
        }
      }
    ],
    merchantInfo: {
      merchantId: 'BCR2DN6T26Q47MYW',
      merchantName: 'Credee Corporation'
    },
    transactionInfo: {
      totalPriceStatus: 'FINAL',
      totalPriceLabel: 'Total',
      totalPrice: '10',
      currencyCode: 'USD',
      countryCode: 'US'
    }
  };
  constructor(
    public httpClient: HttpClient,
    public mainservice: MainService) {
  }
  ngOnInit() {
  }
  onLoadPaymentData($event) {
    // tslint:disable-next-line:max-line-length
    if ($event && $event.detail && $event.detail.paymentMethodData && $event.detail.paymentMethodData.tokenizationData && $event.detail.paymentMethodData.tokenizationData.token) {
      const paymentToken = $event.detail.paymentMethodData.tokenizationData.token;
      this.confirmPayment.emit({ token: JSON.parse(paymentToken).id, payment_source_type: 4, wallet: 2 });
    } else {
      this.stripe = Stripe(this.mainservice.stripe_pk);
      this.paymentRequest.transactionInfo.totalPrice = (this.final_amount || 1).toString();
      // tslint:disable-next-line:max-line-length
      this.paymentRequest.allowedPaymentMethods[0].tokenizationSpecification.parameters['stripe:publishableKey'] = this.mainservice.stripe._apiKey;
      this.paymentsClient = new google.payments.api.PaymentsClient({ environment: this.current_env });
      this.paymentsClient.loadPaymentData(this.paymentRequest).then((paymentData) => {
        const paymentToken = paymentData.paymentMethodData.tokenizationData.token;
        this.confirmPayment.emit({ token: JSON.parse(paymentToken).id, payment_source_type: 4, wallet: 2 });
      }).catch((err) => {
        console.error(err);
      });
    }
  }
}
